import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../RouterCompatibility';
import EditPostbackPage from './EditPostbackPage';
import { actions } from './EditPostbackPage.actions';
import {
    makeGetPostback
} from './EditPostbackPage.selectors';

const makeMapStateToProps = () => {
    const getPostback = makeGetPostback();

    return (state, ownProps) => ({
        postback: getPostback(state, ownProps),
        loading: state.postbacks.list.loading,
        saveSuccess: state.postbacks.saveSuccess
    });
};

const EditPostbackPageComponent = connect(
    makeMapStateToProps,
    function mapDispatchToProps(dispatch) {
        return {
            getListPostbacks: actions.getListPostbacks
        };
    }
)(withRouter(EditPostbackPage));

export default EditPostbackPageComponent;
